import React from 'react';
import { useComponentManager } from '../../providers/ComponentManagerProvider';
import { componentLabel } from './componentLabel';

export const Breadcrumb = ({ onError }) => {
    const { selectedPath, selectAncestor, clearSelection } = useComponentManager();

    const handleClick = index => {
        Promise.resolve(selectAncestor(index)).catch(err => {
            if (onError) onError(err);
        });
    };

    return (
        <nav className="component-manager-breadcrumb" aria-label="Component path" data-testid="component-breadcrumb">
            <button
                type="button"
                className="component-manager-crumb component-manager-crumb-root"
                onClick={clearSelection}
                data-testid="breadcrumb-root"
            >
                Root
            </button>
            {selectedPath.map((component, index) => (
                <React.Fragment key={component.id}>
                    <span className="component-manager-crumb-sep" aria-hidden="true">
                        /
                    </span>
                    <button
                        type="button"
                        className="component-manager-crumb"
                        onClick={() => handleClick(index)}
                        aria-current={index === selectedPath.length - 1 ? 'page' : undefined}
                        data-testid={`breadcrumb-crumb-${index}`}
                    >
                        {componentLabel(component)}
                    </button>
                </React.Fragment>
            ))}
        </nav>
    );
};
